bcl.c.mybLoyaltyTargeting = {
  props: {
    componentSelector: ".myb-loyalty-target-JS",
    targetContentSelector: "div[data-level]",
    hiddenClass: "hidden",
    loyaltyLevel: 0,
  },

  async init(user) {
    // User’s loyalty level
    this.props.loyaltyLevel = await this.getLoyaltyLevel(user, 1000);

    // Check if the component is present in the DOM
    this.process(document);

    // Listen for AEM’s lazy-load event and process newly injected components (important)
    document.addEventListener("foundation-contentloaded", (event) => this.process(event.target), { passive: true });
  },

  /* ---------- Fetch Loyalty Level  ---------- */
  getLoyaltyLevel(user, timeoutMs) {
    return new Promise((resolve) => {
      let settled = false;

      const timer = setTimeout(() => {
        if (!settled) {
          settled = true;
          resolve(this.levelFromUser(user));
        }
      }, timeoutMs);

      try {
        bcl.c.mybLoyaltyUserInfo.requestUserData((xhr) => {
          if (settled) {
            return;
          }

          clearTimeout(timer);
          settled = true;

          try {
            const data = JSON.parse(xhr.responseText || "{}");
            const level = Number(data.level ?? 0);
            resolve(level);
          } catch (err) {
            console.error("Loyalty – JSON.parse error:", err);
            resolve(this.levelFromUser(user));
          }
        });
      } catch (err) {
        clearTimeout(timer);
        console.error("Loyalty – requestUserData threw:", err);
        resolve(this.levelFromUser(user));
      }
    });
  },

  levelFromUser(user) {
    return user && user.federationId ? Number(user["myb-level"] || 0) : 0;
  },

  process(root) {
    const { componentSelector, targetContentSelector, hiddenClass, loyaltyLevel } = this.props;

    root.querySelectorAll(componentSelector).forEach((component) => {
      if (component.dataset.loyaltyProcessed) {
        return;
      }

      const showSelector = `${targetContentSelector}[data-level="${loyaltyLevel}"]`;
      const removeSelector = `${targetContentSelector}:not([data-level="${loyaltyLevel}"])`;

      // Remove all blocks that don’t match the current level
      component.querySelectorAll(removeSelector).forEach((el) => el.remove());

      const toShow = component.querySelector(showSelector);
      if (toShow) {
        toShow.classList.remove(hiddenClass);
      }

      // Mark this component as processed to avoid duplicate work
      component.dataset.loyaltyProcessed = "1";
    });
  },
};
